import React from "react";

/**
 * Breadcrumb Component
 * Displays navigation breadcrumbs
 */
const Breadcrumb = ({ breadcrumbs }) => {
  return (
    <div className="flex items-center space-x-2 mt-1">
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={index}>
          <span
            className={`text-sm ${
              crumb.isLast ? "text-primary font-medium" : "text-gray-500"
            }`}
          >
            {crumb.label}
          </span>
          {!crumb.isLast && <span className="text-gray-400 text-sm">/</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
